var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/logger.ts
import { Roarr } from "roarr";
var ROARR_LOG_LEVELS = {
  TRACE: 10,
  DEBUG: 20,
  INFO: 30,
  WARN: 40,
  ERROR: 50,
  FATAL: 60
};
if (typeof globalThis !== "undefined") {
  globalThis.ROARR ??= {};
  const isNodeEnv = typeof process !== "undefined" && process.versions?.node;
  const roarrEnabled = isNodeEnv ? process.env.ROARR_LOG === "true" : true;
  const isTestEnv = typeof process !== "undefined" && (process.env.NODE_ENV === "test" || !!process.env.VITEST);
  const defaultLevel = isTestEnv ? ROARR_LOG_LEVELS.FATAL : ROARR_LOG_LEVELS.INFO;
  if (typeof process !== "undefined" && process.env.ROARR_LOG_LEVEL) {
    globalThis.ROARR_LOG_LEVEL = parseInt(
      process.env.ROARR_LOG_LEVEL,
      10
    );
  } else {
    globalThis.ROARR_LOG_LEVEL ??= defaultLevel;
  }
  globalThis.ROARR.write = (message) => {
    if (!roarrEnabled) return;
    const minLevel = globalThis.ROARR_LOG_LEVEL ?? defaultLevel;
    if (process.env.NODE_ENV === "production") return;
    try {
      const parsed = JSON.parse(message);
      const messageLevel = parsed?.context?.logLevel ?? ROARR_LOG_LEVELS.INFO;
      if (messageLevel < minLevel) return;
      console.log("[Roarr]", parsed);
    } catch {
      console.log(message);
    }
  };
}
var globalLogger = Roarr;
function createChildLogger(manager, options) {
  const instanceId = options?.instanceId || Array.from(
    { length: 4 },
    () => Math.floor(Math.random() * 16).toString(16)
  ).join("");
  const roarrLog = Roarr.child({
    manager,
    instanceId,
    ...options?.sessionId && { sessionId: options.sessionId }
  });
  return {
    info: (message, ...args) => roarrLog.info(message, ...args),
    debug: (message, ...args) => roarrLog.debug(message, ...args),
    trace: (message, ...args) => roarrLog.trace(message, ...args),
    flow: (message, context) => context ? roarrLog.child(context).debug(message) : roarrLog.debug(message),
    warn: (message, ...args) => roarrLog.warn(message, ...args),
    error: (message, ...args) => roarrLog.error(message, ...args)
  };
}

export {
  __export,
  globalLogger,
  createChildLogger
};
//# sourceMappingURL=chunk-BVZBF7KP.mjs.map